export const SUCCESS_CONS = {
  title: 'Success',
  description: 'Your feedback link can be found at the bottom of the page.',
  start_over: 'Start over',
}

export const ERROR_CONS = {
  tech_error: {
    title: 'Something went wrong',
    description: 'Please try again',
  },
  invalid_xid: {
    title: 'This feedback link is invalid',
    description: 'Please check that it matches the link that was provided.',
  },
  expired_xid: {
    title: 'We have already received your feedback',
    description: 'The link is one-time use only and feedback has already been submitted.',
  }
};
